import { useEffect, useState } from "react"
import Button2 from "../../../Button/Button2"
import { RuleProvider, useRule } from "./RuleReducer"
import ListOption from "../EditAutomations/ListOption"
import { useScrollTrigger } from "@mui/material"
import classes from '../CreateRule/SelectOutputs.module.css'
import ProgressBar from "./ProgressBar"

const ChooseAffectedPin = ({navigate, pins, smartLocks, createRule}) => {

    const { state, dispatch } = useRule(RuleProvider);
    const [progress, setProgress] = useState(60)

    const [message, setMessage] = useState()

    let filteredPins = pins.filter(pin => 
        pin.type !== "INPUT" && 
        pin.type !== "VIRTUAL_INPUT" && 
        (!smartLocks.some(lock => parseInt(lock.outputPin) === pin.Pin)) &&
        pin.Pin !== state.pinNumber);

    const HandlePinSelected = (pin) => {
        console.log(pin)
        console.log(state.selectedPinsToAffect)
        const isPinSelected = state.selectedPinsToAffect.some(p => p === pin);
        console.log(isPinSelected)
        HandleText()
        dispatch({
            type: "SET_SELECTED_PINS_TO_AFFECT",
            payload: isPinSelected
                ? state.selectedPinsToAffect.filter(p => p.Pin !== pin.Pin)
                : [...state.selectedPinsToAffect, pin] 
        });
    };

    useEffect(() =>{
        console.log(state.selectedPinsToAffect)
    }, [state.selectedPinsToAffect])

    const HandleText = () => {
        let sentence;
        let inputType;
            switch (state.inputTypeCopy) {
                case 0:
                    inputType = `${state.pinStatusOn}`;
                    break;
                case 1: 
                    inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`;
                    break;
                case 2:
                    inputType = `${state.pinStatusOff}`;
                    break;
                default:
                    inputType = "unknown";
                    break;
            }

            console.log(state.isLock)
        
        if (state.isLock){
            inputType = "opened"
        }
        
        if (state.isRegularOutput && !state.isInput){
            return `When ${state.pinName} is ${inputType}, ${state.selectedPinsToAffect.map(pin => pin.pinName).join(", ")} will match the state`;
        }
        
        return `When ${state.pinName} is ${inputType}, ${state.selectedPinsToAffect.map(pin => pin.pinName).join(", ")}`;
    }

    const HandleNavigate = (direction) => {

        if (direction === "back"){
            console.log(state.isInput)
            console.log(state.supportsOutputPulse)
            console.log(state.supportsInputPulse)
            if (state.isInput || state.supportsOutputPulse || state.supportsInputPulse){
                navigate(1)
                return;
            } else {
                navigate(0)
                return;
            }
        }

        if (state.selectedPinsToAffect.length > 0) {
            console.log(state.isInput)
            console.log(state.supportsOutputPulse)
            if (state.isInput || state.supportsOutputPulse){
                console.log("here")
                navigate(3)
            } else {
                console.log(state.selectedPinsToAffect)
                createRule(state.inputRule, state.selectedPinsToAffect)
            }
            
        } else {
            setMessage("Please select a switch")
        }
    }
    

    useEffect(() => {
        console.log(state.selectedPinsToAffect);
    }, [state.selectedPinsToAffect]);

    return (
        <div>
            <ProgressBar progress={progress} />
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>
            <div style={{display: "flex", flexDirection:"row", alignItems:"center", justifyContent:"space-between", gap: "20px"}}>
                <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                <ListOption optionText={HandleText()} propsClassName={classes.infoBox} />
                <button className={classes.nextButton} onClick={() => HandleNavigate("next")} >{">"}</button>
            </div>
            <h3 style={{ color:"#6e6e6e"}}>Which switches should change state when the rule triggers?</h3>
            {message && <p style={{color: "red"}}>Please select a switch</p>}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    {filteredPins.map((pin, index) => {
                        return (
                            <Button2 style={{ 
                                minWidth: "350px", 
                                minHeight:"50px", 
                                backgroundColor: state.selectedPinsToAffect.find(Pin => Pin.Pin == pin.Pin) && 
                                "var(--Primary-Color)", color: state.selectedPinsToAffect.find(Pin => Pin.Pin == pin.Pin) && 
                                "white", 
                                border: state.selectedPinsToAffect.find(Pin => Pin.Pin == pin.Pin) && 
                                "2px solid lightblue", minWidth: "350px"}
                            } 
                            key={index} onClick={() => HandlePinSelected(pin)}>
                                {pin.pinName}
                            </Button2>
                        )
                    })}
                </ul >
                
                </div>
            </div>
        </div>
    )
}

export default ChooseAffectedPin;